import React, { useEffect, useState } from 'react';
import ClearIcon from '@mui/icons-material/Clear';
import { OwnerPerfomanceColumn } from './utils/headerJson';
import dayjs from 'dayjs';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import SearchIcon from '@mui/icons-material/Search';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { useDispatch } from 'react-redux';
import { getOgdCostByYear } from '../../../redux/features/CRDslice';
import InputAdornment from '@mui/material/InputAdornment';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import CircularProgress from '@mui/material/CircularProgress';
import TablePagination from '@mui/material/TablePagination';
import Box from '@mui/material/Box';
import { useSelector } from 'react-redux';
export default function OgdFooterTableLanding() {
  const [year, setYear] = useState(dayjs().year());
  const [search, setSearch] = useState('');

  const [pagination, setPagination] = useState({
    page: 0,
    rowsPerPage: 10,
  });

  const ogdCostByYear = useSelector((state) => state.crd.ogdCostByYear.data);
  const ogdCostByYearLoading = useSelector((state) => state.crd.ogdCostByYear.loading);
  const ogdCostByYearMeta = useSelector((state) => state.crd.ogdCostByYear.meta);

  const dispatch = useDispatch();

  useEffect(() => {
    const params = {
      year,
      page: pagination.page + 1,
      limit: pagination.rowsPerPage,
      search: search,
    };
    const ogdCostByYearSignal = dispatch(getOgdCostByYear(params));

    return () => {
      ogdCostByYearSignal.abort();
    };
  }, [dispatch, search, year, pagination]);

  return (
    <Stack gap={1}>
      <Stack direction={'row'} justifyContent={'space-between'}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            views={['year']}
            label="year"
            sx={{ maxWidth: 180 }}
            onChange={(v) => setYear(v?.isValid() ? v?.year() : null)}
            value={year ? dayjs().year(year) : year}
          />
        </LocalizationProvider>

        <TextField
          variant="outlined"
          placeholder="Search"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          sx={{
            alignSelf: 'flex-end',
            maxWidth: 250,
            bgcolor: 'white',
            '& .MuiOutlinedInput-root': {
              borderRadius: '8px',
            },
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="start">
                {search ? (
                  <ClearIcon onClick={() => setSearch('')} sx={{ cursor: 'pointer' }} />
                ) : (
                  <SearchIcon color="action" />
                )}
              </InputAdornment>
            ),
          }}
        />
      </Stack>

      <Paper sx={{ width: '100%', overflow: 'hidden', border: '1px solid #98bcec' }}>
        <TableContainer
          sx={{
            maxHeight: 600,
            overflowY: 'auto',
            position: 'relative',
          }}
        >
          <Table
            sx={{
              flex: 1,
              minWidth: 650,
              '& .MuiTableCell-root': {
                borderBottom: '1px solid #dfdfdfff',
                borderLeft: '1px solid #dfdfdfff',
              },
            }}
          >
            <TableHead
              sx={{
                bgcolor: '#98bcebff',
                position: 'sticky',
                top: 0,
                zIndex: 1,
              }}
            >
              <TableRow>
                {OwnerPerfomanceColumn.map(({ headerName, width }, i) => (
                  <TableCell sx={{ width }} key={i}>
                    {headerName}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {ogdCostByYearLoading ? (
                <TableRow>
                  <TableCell align="center" colSpan={5}>
                    <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
                      <CircularProgress />
                    </Box>
                  </TableCell>
                </TableRow>
              ) : ogdCostByYear?.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={5} align="center" sx={{ color: 'gray', py: 3 }}>
                    No Data Found
                  </TableCell>
                </TableRow>
              ) : (
                ogdCostByYear.map((values, i) =>
                  values?.months?.map((monthValues, index) => (
                    <TableRow>
                      {index === 0 && <TableCell rowSpan={values?.months.length}>{values?.ogaName}</TableCell>}
                      {OwnerPerfomanceColumn.slice(1).map(({ field }, i) => (
                        <TableCell
                          key={`${index}-${i}`}
                          sx={{
                            color:
                              field === 'profit_loss' ? (monthValues?.profit_loss <= 0 ? 'red' : 'green') : 'black',
                          }}
                        >
                          {monthValues?.[field]}
                        </TableCell>
                      ))}
                    </TableRow>
                  )),
                )
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          sx={{ bgcolor: '#dfdfdfff' }}
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={ogdCostByYearMeta?.totalRecords || 0}
          rowsPerPage={pagination.rowsPerPage}
          page={pagination.page}
          onPageChange={(e, page) => setPagination((prev) => ({ ...prev, page }))}
          onRowsPerPageChange={(e) => setPagination((prev) => ({ ...prev, rowsPerPage: e.target.value }))}
        />
      </Paper>
    </Stack>
  );
}
